import $ from 'jquery';
import { Swiper } from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

/* Modèles */
new Swiper('.models-swiper', {
  modules: [Navigation, Pagination],
  slidesPerView: '1',
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-model-next',
    prevEl: '.swiper-button-model-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
  },
});

/* Témoignages */
new Swiper('.testimonials-swiper', {
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-testimonial-next',
    prevEl: '.swiper-button-testimonial-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
  },
});

/* Product */
const productThumbs = new Swiper('.swiper-product-thumbs', {
  modules: [Navigation, Thumbs],
  spaceBetween: 10,
  slidesPerView: 3,
  freeMode: true,
  watchSlidesProgress: true,
});

const product = new Swiper('.swiper-product', {
  modules: [Navigation, Thumbs],
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-product-next',
    prevEl: '.swiper-button-product-prev',
  },
  thumbs: {
    swiper: productThumbs,
  },
});

/* Galerie */
new Swiper('.testimonial-gallery', {
  modules: [Navigation, Pagination],
  slidesPerView: '1',
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-testimonial-next',
    prevEl: '.swiper-button-testimonial-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    1440: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  },
});